import { useCallback, useContext } from 'react';
import { HotsauceContext } from '@providers/hotsauceContext';
import type { AddToastProps } from '@providers/hotsauceContext';

const TOAST_TIMEOUT = 6000;

interface UseNotify {
  showToast: (props: AddToastProps) => void;
}

export function useNotify(): UseNotify {
  const { addToast, removeToast } = useContext(HotsauceContext);

  const showToast = useCallback((props: AddToastProps) => {
    const createdToastId = addToast(props);
    setTimeout(() => {
      removeToast(createdToastId);
    }, TOAST_TIMEOUT);
  }, []);

  return {
    showToast,
  };
}
